module.exports = __webpack_public_path__ + "static/media/user-image.bdcb79fe.png";